import type { FaireProductEntity } from "../../entity_types/product";

export const p_dp27ujh2z4: FaireProductEntity = {
  token: "p_dp27ujh2z4",
  type: "product",
  name: "Old-Fashioned Christmas holiday greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/56036e3b31e6c28324a9f18b5fb8382bf82868f8b52bcee3ce61dd7c50a9807d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eaafc7cfe7cd4d7b544afc30e4d6ff38284d01baf27dac9a55a55320fe36ffd2.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "Blank inside.\n100lb heavyweight card stock.\nOffset printed.\n4.25 x 5.5 inches.\nIllustrated by Dylan Mierzwinski.\nPrinted by Red Cap Cards in Los Angeles, California, USA, on recycled paper.\n\nAvailable as both single cards and pre-packaged boxed cards.\n• Each single card comes with an envelope and a cellophane sleeve.\n• Boxed sets are 8 cards with envelopes and are to be sold as packaged, not to be re-sold as individual cards.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:19.785Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
